export default __webpack_public_path__ + "static/media/visual.aa1ede29.svg";